import React from 'react'

const WorkerPrivacyPolicy = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        Privacy Policy
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <div>
                        <>
                            <p>
                                <strong>Last Updated:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}01 March 2026</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly is operated by Redqubes Private Limited, a company incorporated under the laws of India, having its registered office at P No: 3 DCM Road Jaipur Rajasthan 302021. We provide an on-demand platform that connects homeowners and businesses seeking professional cleaning services ("Customers") with independent service providers.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    This Privacy Policy explains how we collect, use, and protect your personal information in accordance with applicable laws, including India’s DPDP Act. By using Maidly, you consent to the practices described below, which are designed to ensure a safe, reliable, and personalized cleaning experience.
                                </span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Your privacy is the foundation of the trust you place in us. When you use Maidly, you trust us with your personal information, home address, and access to your private space. We are committed to maintaining that trust. This Privacy Policy describes how we collect, use, process, and disclose your information across the Maidly Application, website, and other linked services.
                                </span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>1. Information We Collect</strong></p>
                            <p>&nbsp;</p>

                            <p><strong>A. Information You Provide to Us</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Account Information:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}When you register, we collect your full name, email address, phone number, and profile picture.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Service Address:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We collect your specific home or office address to facilitate the cleaning service.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Identity Verification (Partners):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}For our service providers, we collect government-issued identification (Aadhaar, Driver’s License, or Passport), proof of address, and background check documentation to ensure platform safety.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Communication Data:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We collect and store any messages, photos, or videos exchanged between Customers and Partners through our in-app chat feature to monitor service quality and resolve disputes.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Precise Real-Time Location:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We collect location to ensure accurate service delivery. Customers may opt to disable location tracking in settings, but this may affect certain app features. Partners’ locations are tracked only during active service periods.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Information Collected Automatically (While Using the App)</strong></p>
                            <p><strong>Precise Real-Time Location</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>For Customers: We collect your location to:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Suggest the nearest available service providers.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Auto-fill your service address for faster booking.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Allow you to see your Maid’s real-time arrival.</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>You can disable location tracking in your device settings; however, some features, like live arrival tracking, may not work.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <span style={{ fontWeight: 400 }}>For Service Providers (Maids): We collect your location only during active service periods to:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Confirm arrival at the job site.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Calculate travel time.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Ensure your safety while performing the service.</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>You will not be tracked outside your active work hours.</span>
                            </p>
                            <p>&nbsp;</p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Control:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Both Customers and Maids can manage location settings in the app or device settings at any time.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Device Information:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We collect information about the device you use (model, operating system, IP address, and unique device identifiers) to prevent fraud and fix technical bugs.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Usage Data:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We track how you interact with the app—which buttons you click, the duration of your sessions, and your search history for "Deep Clean," "Kitchen Cleaning," etc.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Information from Third Parties</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Payment Processors:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}While we do not store your credit card numbers, we receive transaction confirmations and "tokenized" identifiers from our payment partners Razorpay to confirm your booking is paid.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Background Check Services:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}For service providers, we receive results from third-party verification agencies regarding criminal records or professional history.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Social Logins:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you choose to sign up via Google, Facebook, or Apple, we receive your basic profile info (name and email) from those platforms.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Cookies and Tracking Technologies</strong></p>
                            <p><strong>Purpose of Cookies &amp; Tracking</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We use cookies, web beacons, and mobile identifiers to:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Keep you logged in across sessions.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Remember your cleaning preferences.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Analyze app usage to improve features and performance.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Measure the effectiveness of our marketing campaigns.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p><strong>Types of Cookies</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Essential cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Required for the app to function properly.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Non-essential cookies:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Used for analytics, personalization, and marketing.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p><strong>Your Control</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You can manage cookies in your device or browser settings.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Non-essential cookies will only be used if you give your consent.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>You can withdraw consent at any time from the “Privacy Settings” section in the app.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p><strong>Third-Party Tracking</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>We may use third-party analytics and marketing services that use cookies or similar technologies.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>These third parties are contractually bound to protect your data and comply with applicable laws.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>2. How We Use Your Information</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We do not just collect data; we use it to create a reliable and safe cleaning experience. Specifically, we use your information for:</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Providing and Improving Our Services</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Matchmaking:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use location data and service preferences to connect Customers with the most suitable nearby Maids.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Transaction Processing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use your contact and payment details to facilitate bookings, process payments, and send electronic receipts/invoices.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>App Optimization:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We analyze usage data to fix bugs, improve app speed, and design new features.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Safety, Security, and Verification</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Background Screening:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use Service Providers’ ID data to conduct rigorous background checks, ensuring only verified professionals enter our users' homes.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Identity Protection:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use phone numbers and emails to verify accounts (via OTP) to prevent "bot" accounts or fraudulent bookings.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>In-App Communication:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We monitor in-app chats and calls to ensure the safety of both parties and to have a record in case of a dispute or safety incident.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Live Tracking:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use real-time GPS data so Customers can see exactly when their Maid will arrive, providing peace of mind and better scheduling.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Customer Support &amp; Dispute Resolution</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Troubleshooting:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}If you have an issue with a booking, our support team uses your account history and chat logs to investigate and resolve the problem quickly.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Refunds and Credits:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use transaction data to process refunds or apply promotional credits to your account.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Marketing and Personalization</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Personalized Offers:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We may use your past booking history to send you relevant discounts.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Newsletters:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}With your consent, we send updates about new services or seasonal cleaning tips. You can opt-out of these at any time.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>E. Legal and Compliance</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Regulatory Requirements:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use and store data to comply with local tax laws, labor regulations, and to cooperate with law enforcement if a legal request is made.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Promotional Communications:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}With your explicit consent, we may send offers, newsletters, or service tips. You can opt out at any time via your profile settings.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>F. Legal Basis for Processing</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We process your personal data based on the following lawful grounds under applicable law:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Your Consent:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}For marketing communications, non-essential cookies, and optional features.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Performance of a Contract:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To provide and manage cleaning services, process payments, and facilitate bookings.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Legal Obligations:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}To comply with tax laws, fraud prevention requirements, and lawful requests from authorities.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Legitimate Uses:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}As permitted under the Digital Personal Data Protection Act, 2023 and other applicable laws.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>3. Data Sharing and Disclosure</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We believe in "Data Minimization"—sharing only what is absolutely necessary to complete a service. We share your information in the following limited circumstances:</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Sharing Between Users (The Core Service)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>To facilitate a successful cleaning appointment, Maidly shares specific details between the Customer and the Service Provider:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>From Customer to Maid:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Once a booking is confirmed, we share the Customer’s first name, service address, phone number, and any specific cleaning instructions or photos of the premises.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>From Maid to Customer:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We share the Maid’s name, profile photo, average rating, and real-time GPS location (only while the Maid is en route to or at the job site).</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Sharing with Third-Party Service Providers</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We use carefully selected third-party partners to make Maidly work smoothly and securely. Your information is shared only as necessary for the service, and all partners are contractually obligated to keep it safe.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Payment Processors:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We share transaction details with partners like Razorpay to securely process payments and prevent fraud. We do not share your full credit card or CVV numbers.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Cloud Hosting:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Your data is stored on secure servers. Where personal data is transferred outside India, such transfers are made only to jurisdictions permitted under applicable Indian data protection laws and subject to appropriate safeguards.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Verification Services:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Service Providers’ IDs and background check information are shared with specialized agencies to verify identity and safety.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Communication Tools:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use third-party services like Twilio or Firebase to send SMS notifications and in-app alerts.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Your control:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We share only the minimum data necessary for each service. You can review and update your personal information in the app at any time.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Legal Requirements and Protection</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We may disclose your information if we believe in good faith that it is necessary to:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Comply with a legal obligation, subpoena, or court order.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Protect and defend the rights or property of Maidly.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Prevent or investigate possible wrongdoing in connection with the Service.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Protect the personal safety of our users or the public.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Business Transfers</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>In the event that Maidly undergoes a merger, acquisition, or sale of assets, your personal information may be transferred as a business asset. We will notify you via email or a prominent notice in the app before your data becomes subject to a different privacy policy. Some information may be processed outside India; in such cases, we ensure compliance with applicable law and data protection safeguards.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>E. With Your Explicit Consent</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We will ask your permission before sharing your data for marketing. We may share anonymized or aggregated data with third-party analytics partners. All partners are contractually required to maintain equivalent security standards. For services hosted outside India, data transfer is protected under applicable law.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>4. Your Privacy Choices</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We believe you should have full control over your personal information. You can manage your privacy through the following tools:</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Access and Updates</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>You can review and change your personal information (name, phone number, and saved addresses) at any time by logging into the Maidly App and visiting the "Profile Settings" section.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>B. Location Services</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Granular Control:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can opt to provide your location only while using the app or "Always" for better background tracking (recommended for Maids).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Opt-Out:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can disable location permissions in your device’s system settings.</span>
                                </li>
                            </ul>
                            <p>
                                <strong>Note:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}If you disable location, you will have to enter your service address manually, and you will not be able to see the real-time arrival of your Maid.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>C. Communication Preferences</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Push Notifications:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We send alerts about booking status and safety. You can turn these off in your phone settings, but you may miss important updates about your cleaning.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Marketing Emails:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}You can opt-out of promotional emails by clicking the "Unsubscribe" link at the bottom of any email.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Transaction Alerts:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Please note that you cannot opt-out of essential service emails, such as payment receipts or security alerts.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Data Portability</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>You have the right to request a copy of the personal data we hold about you in a machine-readable format. To request this, please email us at support@redqubes.com.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>E. Account Deletion and the "Right to be Forgotten"</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If you no longer wish to use Maidly, you can request to delete your account:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>How to Delete:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Submit a deletion request through in-app Support.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>What Happens Next:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Once requested, we will deactivate your account and delete your personal data from our active databases within 30 days, except for data we are legally required to keep (such as tax invoices or dispute records).</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>F. Do Not Track (DNT)</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Currently, our systems do not respond to "Do Not Track" signals from web browsers, as there is no universal standard for how to interpret them.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>5. Security measures</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>At Maidly, we take the security of your data and your home seriously. We implement a multi-layered security framework designed to protect your information from unauthorized access, loss, or misuse.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Technical Safeguards</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Encryption in Transit:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}All data sent between the Maidly App and our servers is encrypted using Industry-Standard TLS (Transport Layer Security). This ensures that sensitive information, like your address and chat messages, cannot be intercepted by third parties.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Encryption at Rest:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Sensitive user data, including personal identifiers and background check results, is stored on secure servers using AES-256 encryption.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Secure Payment Processing:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We follow PCI-DSS (Payment Card Industry Data Security Standard) compliance. We do not store your full credit card numbers or CVVs on our own servers; all financial data is handled by our secure, certified payment partners.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Access Control &amp; Monitoring</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Principle of Least Privilege:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}Access to user data is strictly limited to authorized Maidly employees who require that information to perform their jobs (e.g., our Customer Support team).</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Two-Factor Authentication (2FA):</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We use OTP verification via SMS or email for every login attempt to prevent unauthorized access to your account.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Regular Audits:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We conduct periodic security audits and vulnerability assessments to identify and patch potential weaknesses in our system.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Physical and Operational Security</strong></p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Vetted Partners:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}For every Maid on our platform, we collect and securely store government-issued IDs and conduct comprehensive background checks before they are allowed to accept bookings.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>In-App Safety Features:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}We provide features such as Masked Phone Numbers and Real-Time GPS Tracking during service hours to ensure the safety of both parties.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>D. Data Breach Notification</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>In the unlikely event of a data breach, we are committed to transparency. We will notify the relevant Data Protection Authorities and affected users within the timeframe required by law (for example, within 72 hours where applicable) via email or in-app notification.</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Employee Security Training:</strong>
                                    <span style={{ fontWeight: 400 }}>{" "}All Maidly employees undergo regular security training to protect user data. System access and logs are monitored to detect and prevent unauthorized activity.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>6. Children’s Privacy</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Maidly is a professional service marketplace intended solely for use by individuals who are at least 18 years of age (or the age of majority in your jurisdiction).</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Age Restrictions</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Our services are not designed for, marketed to, or intended for use by children under the age of 18. We do not knowingly collect, maintain, or use personal information from children.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>B. Parental Controls and Deletion</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If we discover that a person under the age of 18 has created an account or provided us with personal information, we will take immediate steps to:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Terminate the account.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Delete the associated data from our servers as quickly as possible.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>C. Reporting a Minor</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If you are a parent or guardian and you believe that your child has provided us with personal information without your consent, please contact us immediately at support@redqubes.com. We will work with you to ensure that the information is removed and the account is closed.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>7. Changes to This Policy</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>As Maidly evolves and we introduce new features or comply with new legal requirements, we may update this Privacy Policy from time to time.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>A. Notification of Changes</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If we make any material changes (such as how we share your location or process payments), we will notify you through one or more of the following channels:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>A prominent notification within the Maidly App dashboard.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>An email sent to the address associated with your account.</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>A notice on our website’s homepage.</span>
                                </li>
                            </ul>
                            <p>&nbsp;</p>

                            <p><strong>B. Reviewing the Policy</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We encourage you to review this page periodically to stay informed about how we are protecting the personal information we collect. The "Last Updated" date at the top of this policy will indicate when the latest changes were made.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>C. Continued Use</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Your continued use of the Maidly Application or our Services after any changes to this Privacy Policy constitutes your acceptance of the updated terms. If you do not agree with the revised policy, your sole remedy is to stop using the App and request the deletion of your account.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>8. Data Retention</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We retain personal data only for as long as necessary to:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Provide and manage our services</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Comply with legal and regulatory obligations</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Resolve disputes</span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <span style={{ fontWeight: 400 }}>Enforce our agreements</span>
                                </li>
                            </ul>
                            <p>
                                <span style={{ fontWeight: 400 }}>Active account data is retained while your account remains operational.</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>If your account becomes inactive, we may delete or anonymize your data after a reasonable period unless retention is required under applicable law.</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Certain financial records, invoices, and tax-related documents may be retained for the period required under Indian law.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>Grievance Officer (as required under applicable Indian law):</strong></p>
                            <p>
                                <strong>Name:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}SK Saif</span>
                            </p>
                            <p>
                                <strong>Email:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}support@redqubes.com</span>
                            </p>
                            <p>
                                <strong>Address:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}P No: 3 DCM Road, Jaipur, Rajasthan 302021</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We will acknowledge your grievance within 48 hours and aim to resolve it within 30 days in accordance with applicable law.</span>
                            </p>
                            <p>&nbsp;</p>

                            <p><strong>9. Contact Us</strong></p>
                            <p>
                                <span style={{ fontWeight: 400 }}>We believe in open communication. If you have questions about this Privacy Policy, your data rights, or how we handle your home’s security, please use the specific channels below to ensure your inquiry reaches the right department.</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>For questions regarding how we use your data, requests for data access, or updates to your personal information:</span>
                            </p>
                            <p>
                                <strong>Email:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}support@redqubes.com</span>
                            </p>
                            <p>
                                <strong>Phone:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}+91 92576 52266</span>
                            </p>
                            <p>
                                <strong>Response Time:</strong>
                                <span style={{ fontWeight: 400 }}>{" "}We aim to respond to all privacy-related inquiries within 24–48 hours.</span>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Please include your Booking ID to help us process your request faster.</span>
                            </p>

                        </>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WorkerPrivacyPolicy